import { ValidPosition } from '@bakerweb/models';

const MUNI_RPT_SEC_CLASSES = [4, 5, 21, 22, 1004, 1005, 1006, 1007];

export function getMuniPositions(positions: ValidPosition[]) {
  return positions.filter(({ apmRptSecClass }) => MUNI_RPT_SEC_CLASSES.includes(apmRptSecClass));
}
